
export default {
	name: 'PZTabs',
	props: {
		list: {
			type: Array,
			default: () => []
		},
		value: {
			type: [String, Number, null],
			require: true
		}
	},
	components: {},
	data() {
		return {}
	},
	computed: {},
	methods: {},
	mounted() {
		// console.log('PZTabs mounted', this.list)
	}
}
